import React from "react";
import { typography } from "@streeteasy/design-system";
import { bool, func, string } from "prop-types";

import * as S from "./styled";

const { H6, P } = typography;

const ListingAgentDescription = ({
  agentImageSrc,
  agentName,
  agentTitle,
  brokerage,
  className,
  descriptionTextId,
  handleContactBuyersAgentClick,
  isPro
}) => (
  <div className={className}>
    <S.AgentDescriptionHeader>
      <S.AgentImage isPro={isPro} src={agentImageSrc} />
      <S.AgentInfoContainer>
        <H6>{agentName}</H6>
        <P>{agentTitle}</P>
        <P>{brokerage}</P>
      </S.AgentInfoContainer>
    </S.AgentDescriptionHeader>
    <P id={descriptionTextId}>
      This agent represents the seller&apos;s interests. If you&apos;re looking
      to buy, contact a StreetEasy Expert.{" "}
      <S.ContactBuyersAgentButton onClick={handleContactBuyersAgentClick}>
        Contact expert
      </S.ContactBuyersAgentButton>
      .
    </P>
  </div>
);

ListingAgentDescription.propTypes = {
  agentImageSrc: string,
  agentName: string.isRequired,
  agentTitle: string.isRequired,
  brokerage: string.isRequired,
  className: string,
  descriptionTextId: string,
  handleContactBuyersAgentClick: func.isRequired,
  isPro: bool
};

ListingAgentDescription.defaultProps = {
  agentImageSrc: null,
  className: null,
  descriptionTextId: null,
  isPro: false
};

export default ListingAgentDescription;
